import { useState, useMemo } from "react";
import { ExclamationTriangleIcon, CopyIcon } from "../../../assets/icons";
import FormField from "../../FormField/FormField";
import AutoriTable from "../AutoriTable/AutoriTable";
import UploadBiblografia from "../UploadBiblografia/UploadBiblografia";
import TipologiaPubblicazioni from "../../../assets/json/tipologia-pubblicazioni.json";
import CustomSelect from "../../Common/CustomSelect/CustomSelect";
import UploadCover from "../UploadCover/UploadCover";
import RepertiInteressati from "../RepertiInteressati/RepertiInteressati";

const PubblicazioniDetailForm = ({
  showIssues,
  issues,
  disabled = false,
  formData,
  bibliografiaStructure,
  copyToClipboard,
  handleFormDataChange,
  create = false
}) => {
  const [tipoDocumentoKey, setTipoDocumentoKey] = useState(0);

  const handleSelectChange = (name, option) => {
    handleFormDataChange("tipoDocumento", option.value);
    setTipoDocumentoKey((prevKey) => prevKey + 1);
  };

  const customOptions = useMemo(() => {
    return TipologiaPubblicazioni.map((item) => ({
      label: item.tipo,
      value: item.tipo,
    }));
  }, []);


  return (
    <div className="content-wrapper">
      <div className="issue-container">
        {showIssues &&
          issues.map((issue, index) => {
            return (
              <div key={index} className="issue">
                <p className="issue-icon">
                  <ExclamationTriangleIcon />{" "}
                </p>
                {issue}
              </div>
            );
          })}
      </div>
      <div className="blocks-container">
         <div className="form-block" id="pubblicazione-generalità">
          <p className="section-title"> GENERALITÀ</p>
          <FormField
            fieldStructure={bibliografiaStructure["titolo"]}
            value={formData["titolo"]}
            onChange={(newValue) => handleFormDataChange("titolo", newValue)}
            disabled={disabled}
          />
          { create !== true && (
          <FormField
            fieldStructure={bibliografiaStructure["abbreviazione"]}
            value={formData["abbreviazione"]}
            onChange={(newValue) =>
              handleFormDataChange("abbreviazione", newValue)
            }
            disabled={true}
          />
          )}
          <FormField
            fieldStructure={bibliografiaStructure["annoPubblicazione"]}
            value={formData["annoPubblicazione"]}
            onChange={(newValue) =>
              handleFormDataChange("annoPubblicazione", newValue)
            }
            disabled={disabled}
          />
          <CustomSelect
            key={`tipo-${tipoDocumentoKey}`}
            options={customOptions}
            initValue={{
              label: formData["tipoDocumento"],
              value: formData["tipoDocumento"],
            }}
            name="tipoDocumento"
            label={"Tipo documento"}
            disabled={disabled}
            placeholder="Seleziona tipo documento"
            onChange={handleSelectChange}
          />
          <FormField
            fieldStructure={bibliografiaStructure["editore"]}
            value={formData["editore"]}
            onChange={(newValue) => handleFormDataChange("editore", newValue)}
            disabled={disabled}
          />
        </div>
        <UploadCover
          allegati={formData?.allegati}
          disabled={disabled}
          onChange={(newValue) => handleFormDataChange("allegati", newValue)}
        />
        <div className="form-block" id="pubblicazione-dati-aggiuntivi">
          <p className="section-title"> DATI AGGIUNTIVI</p>
          <FormField
            fieldStructure={bibliografiaStructure["pagine"]}
            value={formData["pagine"]}
            onChange={(newValue) => handleFormDataChange("pagine", newValue)}
            disabled={disabled}
          />

          <FormField
            fieldStructure={bibliografiaStructure["volume"]}
            value={formData["volume"]}
            onChange={(newValue) => handleFormDataChange("volume", newValue)}
            disabled={disabled}
          />
          <FormField
            fieldStructure={bibliografiaStructure["paginaInizio"]}
            value={formData["paginaInizio"]}
            onChange={(newValue) =>
              handleFormDataChange("paginaInizio", newValue)
            }
            disabled={disabled}
          />
          <FormField
            fieldStructure={bibliografiaStructure["paginaFinale"]}
            value={formData["paginaFinale"]}
            onChange={(newValue) =>
              handleFormDataChange("paginaFinale", newValue)
            }
            disabled={disabled}
          />
        </div>
        <div className="form-block" id="pubblicazione-autori">
            <p className="form-block-header-title">Autori</p>
            <AutoriTable
              autori={formData?.autori}
              edit={!disabled}
              onChange={(newValue) => handleFormDataChange("autori", newValue)}
            />
        </div>
        <RepertiInteressati reperti={formData?.reperti} />
         <UploadBiblografia
            idPdfBibliografia={formData?.allegati}
            disabled={disabled}
            onChange={(newValue) => handleFormDataChange("allegati", newValue)}
          />
      </div>
    </div>
  );
};

export default PubblicazioniDetailForm;
